import type { SentryFlowTier, SentryIncidentPriority } from './types';
import {
  DEFAULT_INCIDENT_PRIORITY,
  FLOW_TIER_PRIORITY,
  LEGACY_PRIORITY,
} from './constant';

export {
  DEFAULT_INCIDENT_PRIORITY,
  FLOW_TIER_PRIORITY,
  LEGACY_PRIORITY,
} from './constant';

export const incidentPriorityToLegacyTag = (
  priority: SentryIncidentPriority,
): string | undefined => LEGACY_PRIORITY[priority];

export const priorityFromFlowTier = (
  tier: SentryFlowTier,
): SentryIncidentPriority => FLOW_TIER_PRIORITY[tier];
